module.exports = __webpack_public_path__ + "katarzyna.jpg?4331f79bf765d689be120429890b86b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artists/katarzyna.jpg
// module id = 303
// module chunks = 0